// Simple reusable <img onError> handler to swap to a fallback image.
// Prevents infinite loops if the fallback itself fails.
export const withImageFallback = (fallbackSrc) => (event) => {
  const img = event?.currentTarget;
  if (!img || !fallbackSrc) return;

  if (img.dataset?.fallbackApplied === "true") return;
  img.dataset.fallbackApplied = "true";

  img.src = fallbackSrc;
};
